<div class="dropdownPopup industryPopUp">
        <div class="popupHeader">
            <h3 class="font-16 medium">Industry & Sector (Select all that apply)</h3>
            <div class="buttonWrapp">
                <button id="modules_registration_module_industry_dialog_1" mat-button mat-dialog-close class="btnCustom btn-outline" (click)="closeDialog(false)">Cancel</button>
                <button id="modules_registration_module_industry_dialog_2" mat-button mat-dialog-close class="btnCustom btn-primary" *ngIf="this.data.editable" (click)="closeDialog(true)">Save</button>
            </div>
        </div>
        
        <div class="dropdownList">
            <div class="itemsList">
                <ul class="scroller">
                    <li *ngFor="let industry of industryList; let i = index" [class.active]="isActive(i)">
                        <input id="modules_registration_module_industry_dialog_3" type="checkbox" [checked]="isIndustryChecked(i)"  class="input-hidden" disabled />
                        <label class="checkContent " [for]="industry.id" (click)="clickIndustry(i)">
                            <div class="customCheck">
                                <mat-icon>check</mat-icon>
                            </div>
                            {{industry.industryName}}
                        </label>
                    </li>
                </ul>
            </div>
            <div class="subItems">
                <div class="d-flex">
                    <div class="formGroup checkboxItem width50" *ngFor="let sector of industryList[this.clickedIndustry].sectors">
                        <mat-checkbox [checked]="sector.isChecked?sector.isChecked:false" (click)="toggleValueCheckIndustry($event,sector)" [disabled]="!this.data.editable">
                            {{sector.sectorName}}
                        </mat-checkbox>
                    </div>
                </div>  
            </div>
        </div>
</div>